import { render, staticRenderFns } from "./termeni_conditii.vue?vue&type=template&id=a4a0aec6"
import script from "./termeni_conditii.vue?vue&type=script&lang=js"
export * from "./termeni_conditii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports